import Icon from "@/componentsDS/Icon/Icon";
import Tags from "@/componentsDS/Tags/Tags";
import PropTypes from 'prop-types';

export const STATUS = {
	APPROVED: 'APPROVED',
	ACTIVE: 'ACTIVE',
	INACTIVE: 'INACTIVE',
	REVOKED: 'REVOKED',
	PENDING: 'PENDING',
	PENDING_YOUR_APPROVAL: 'PENDING_YOUR_APPROVAL',
	REJECTED: 'REJECTED',
}

const statusTagProperties = {
	[STATUS.APPROVED]: {
		label: "Approved",
		prefixIcon: <Icon name="check-double" style="solid" size="small" color="#0e7241" />,
		tagClassName: 'DS__tag--success'
	},
	[STATUS.ACTIVE]: {
		label: "Active",
		prefixIcon: <Icon name="check-circle" style="solid" size="small" color="#0e7241" />,
		tagClassName: 'DS__tag--success'
	},
	[STATUS.INACTIVE]: {
		label: "Inactive",
		prefixIcon: <Icon name="x-circle" style="solid" size="small" color="#60636b" />,
		tagClassName: 'DS__tag--neutral'
	},
	[STATUS.REVOKED]: {
		label: "Revoked",
		prefixIcon: <Icon name="x-circle" style="solid" size="small" color="#60636b" />,
		tagClassName: 'DS__tag--neutral'
	},
	[STATUS.PENDING]: {
		label: "Pending Approval",
		prefixIcon: <Icon name="check-history" style="solid" size="small" color="#7a6007" />,
		tagClassName: 'DS__tag--warning'
	},
	[STATUS.PENDING_YOUR_APPROVAL]: {
		label: "Pending Your Approval",
		prefixIcon: <Icon name="check-history" style="solid" size="small" color="#7a6007" />,
		tagClassName: 'DS__tag--warning'
	},
	[STATUS.REJECTED]: {
		label: "Rejected",
		prefixIcon: <Icon name="x-circle" style="solid" size="small" color="#60636b" />,
		tagClassName: 'DS__tag--critical'
	},
}

const StatusTags = ({ status }) => {
	return <Tags {...statusTagProperties[status]} />;
};

StatusTags.propTypes = {
	status: PropTypes.string
};

export default StatusTags;



